import { useQuery } from '@tanstack/react-query';
import {
  fetchMarketSummary,
  getMarketSummaryQueryKey,
  MarketSummary,
} from '@/pages/Market/query/fetchMarketSummary';
import type { getMarketSummary } from '@simplywallst/services';
import useReduxStateMarket, {
  MarketPageType,
} from '@/pages/Market/hooks/useReduxStateMarkets';
import useIndustryGetter from '@/pages/Market/hooks/useIndustryGetter';
type MarketSummaryTemplate = Parameters<typeof getMarketSummary>[0];
const defaultSummary: MarketSummary = {
  text: 'No data',
  sentiment: null,
  virtual: [],
};

export default function (template: MarketSummaryTemplate): {
  summary: MarketSummary;
  isFetching: boolean;
} {
  const { market, marketPageType } = useReduxStateMarket();
  const [{ id }, enabled] = useIndustryGetter();
  const { data, isFetching } = useQuery({
    queryKey: getMarketSummaryQueryKey(market, id ?? 0),
    queryFn: fetchMarketSummary,
    staleTime: Infinity,
    enabled: marketPageType === MarketPageType.MARKET ? true : enabled,
    refetchOnMount: false,
  });

  const summary = (data && data[template]) || defaultSummary;
  return { summary, isFetching };
}
